import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'lib-teste',
  templateUrl: './teste.component.html',
  styleUrls: ['./teste.component.css']
})
export class TesteComponent implements OnInit, OnDestroy{
  @Input() control: FormControl;
  @Input() id: string;
  @Input() label: string = '';
  @Input() msgPattern: string = '';
  @Input() alt: string = '';

  constructor() { }

  ngOnInit() { }

  ngOnDestroy(){
      delete this.control;
      delete this.label;
      delete this.alt;
      delete this.msgPattern;
  }

}